
const namespaced = true;

const windLocalStorage = JSON.parse(localStorage.getItem('windHazard') || 'null')
const floodLocalStorage = JSON.parse(localStorage.getItem('floodHazard') || 'null')
const waterLocalStorage = JSON.parse(localStorage.getItem('waterHazard') || 'null')

const windStarted = JSON.parse(localStorage.getItem('windHazardStarted') || 'false')
const floodStarted = JSON.parse(localStorage.getItem('floodHazardStarted') || 'false')
const waterStarted = JSON.parse(localStorage.getItem('waterHazardStarted') || 'false')


const initialState = () => {
    return {
        windHazard: windLocalStorage || null,
        floodHazard: floodLocalStorage || null,
        waterHazard: waterLocalStorage || null,
        showSurveyTour: true,
        windHazardStarted: windStarted,
        floodHazardStarted: floodStarted,
        waterHazardStarted: waterStarted,
        shouldFetch: false,
    }
}

const state = initialState()

const mutations = {
    SET_WIND_HAZARD_STARTED(state, data) {
        state.windHazardStarted = data
        localStorage.setItem('windHazardStarted', data)
    },
    SET_FLOOD_HAZARD_STARTED(state, data) {
        state.floodHazardStarted = data
        localStorage.setItem('floodHazardStarted', data)
    },
    SET_WATER_HAZARD_STARTED(state, data) {
        state.waterHazardStarted = data
        localStorage.setItem('waterHazardStarted', data)
    },
    UPDATE_WIND_HAZARD(state, data) {
        state.windHazard = data
        localStorage.setItem('windHazard', JSON.stringify(data))
    },
    UPDATE_FLOOD_HAZARD(state, data) {
        state.floodHazard = data
        localStorage.setItem('floodHazard', JSON.stringify(data))
    },
    UPDATE_WATER_HAZARD(state, data) {
        state.waterHazard = data
        localStorage.setItem('waterHazard', JSON.stringify(data))
    },
    SET_SHOW_SURVEY_TOUR(state, data) {
        state.showSurveyTour = data
    },
    SET_SHOULD_FETCH(state, data) {
        state.shouldFetch = data
    },
    LOAD_DEFAULT(state) {
        Object.assign(state, initialState())
    },
    UPDATE_ASSESSMENT_INFO(state, payload) {
        state[payload.survey].assessment = payload.data
        // console.log()
        if (payload.survey === 'waterHazard') {
            localStorage.setItem('waterHazard', JSON.stringify(state.waterHazard))
        } else if (payload.survey === 'windHazard') {
            localStorage.setItem('windHazard', JSON.stringify(state.windHazard))
        } else if (payload.survey === 'floodHazard') {
            localStorage.setItem('floodHazard', JSON.stringify(state.floodHazard))
        }
    },
    DELETE_SURVEY_DATA(state, payload) {/*
        console.log(state[payload.item]) */
        let e = { survey: '', score: '', assessment: '' }
        if (payload.item === 'waterHazard') {
            e['totalWaterStorage'] = 0
            e['isNonStandard'] = false
        }
        Object.assign(state[payload.item], e)
        localStorage.removeItem(payload.item)
    },
}
const actions = {
    SET_WIND_HAZARD_STARTED({ commit }, data) {
        commit("SET_WIND_HAZARD_STARTED", data)
    },
    SET_FLOOD_HAZARD_STARTED({ commit }, data) {
        commit("SET_FLOOD_HAZARD_STARTED", data)
    },
    SET_WATER_HAZARD_STARTED({ commit }, data) {
        commit("SET_WATER_HAZARD_STARTED", data)
    },
    UPDATE_WIND_HAZARD({ commit }, data) {
        commit("UPDATE_WIND_HAZARD", data)
    },
    UPDATE_FLOOD_HAZARD({ commit }, data) {
        commit("UPDATE_FLOOD_HAZARD", data)
    },
    UPDATE_WATER_HAZARD({ commit }, data) {
        commit("UPDATE_WATER_HAZARD", data)
    },
    SET_SHOW_SURVEY_TOUR({ commit }, data) {
        commit("SET_SHOW_SURVEY_TOUR", data)
    },
    setShouldFetch({ commit }, data) {
        commit("SET_SHOULD_FETCH", data)
    },
    loadDefault({ commit }) {
        commit("LOAD_DEFAULT")
    }
}

export default {
    namespaced,
    state,
    mutations,
    actions
}